import { useEffect, useState, useRef } from 'react';
import { Box, MenuItem, Button, List, ListItemButton, ListItemText, Collapse } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import {
  NavMenu,
  navButtonStyles,
  navButtonActiveStyles,
  menuItemStyles,
} from './StyledComponents';

export const ProductToolkitMenuItem = ({ LOB, toggleDrawer }) => {
  const [open, setOpen] = useState(false);
  const isMedium = useMediaQuery('(max-width:1200px)');
  const isMobile = useMediaQuery('(max-width:600px)');
  const anchorRef = useRef(null);
  const location = useLocation();
  const isActive =
    location.pathname.includes('ProductToolkit') || location.pathname.includes('Brokerage')
      ? true
      : false;
  const [mobileOpen, setMobileOpen] = useState(isActive ? true : false);

  const handleToggle = (event) => {
    setOpen((prevOpen) => !prevOpen);
    anchorRef.current = event.currentTarget;
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleMobileToggle = () => {
    setMobileOpen((prevOpen) => !prevOpen);
  };

  useEffect(() => {
    setOpen(false);
  }, [location]);

  if (!LOB || LOB.length === 0) {
    return null;
  }

  const MobileMenuItemStyle = {
    display: 'flex !important',
    padding: '8px 16px !important',
    flexGrow: '0',
  };
  if (isMobile || isMedium) {
    return (
      <List sx={{ width: '100%', bgcolor: 'background.paper', padding: '0px !important' }}>
        <ListItemButton sx={MobileMenuItemStyle} onClick={handleMobileToggle}>
          <ListItemText primary="Products" />
          {mobileOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={mobileOpen} timeout="auto">
          <List
            component="div"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              borderLeft: '1px solid #2CA6FA',
              marginLeft: '1rem',
            }}
            disablePadding
          >
            {LOB &&
              LOB.filter((e) => e.ProductCode !== 'FPRA' && e.Name !== 'Protector Level Term').map(
                (e, index) => (
                  <ListItemButton
                    sx={{
                      ...MobileMenuItemStyle,
                      pl: 4,
                      background:
                        location.pathname.includes(e.ProductCode) ||
                        location.pathname.includes(e.Name)
                          ? '#0000000a'
                          : '',
                    }}
                    component={NavLink}
                    key={`${index}-${e.Name}`}
                    onClick={toggleDrawer}
                    to={
                      e.ProductCode === 'BRK'
                        ? '/Brokerage'
                        : `/ProductToolkit/Index/${e.ProductCode}`
                    }
                  >
                    <ListItemText primary={e.Name} />
                  </ListItemButton>
                )
              )}
          </List>
        </Collapse>
      </List>
    );
  }
  return (
    <Box style={{ borderRadius: 'none' }}>
      <Button
        ref={anchorRef}
        onClick={handleToggle}
        sx={{
          ...navButtonStyles,
          ...(isActive && {
            ...navButtonActiveStyles,
          }),
        }}
      >
        Products
      </Button>
      <NavMenu anchorEl={anchorRef.current} open={open} onClose={handleClose}>
        {LOB &&
          LOB.filter((e) => e.ProductCode !== 'FPRA' && e.Name !== 'Protector Level Term').map(
            (e, index) => (
              <MenuItem
                sx={{
                  ...menuItemStyles,
                  background:
                    location.pathname.includes(e.ProductCode) || location.pathname.includes(e.Name)
                      ? '#0000000a'
                      : '',
                }}
                key={`${index}-${e.Name}`}
                to={
                  e.ProductCode === 'BRK' ? '/Brokerage' : `/ProductToolkit/Index/${e.ProductCode}`
                }
                component={NavLink}
              >
                {e.Name}
              </MenuItem>
            )
          )}
      </NavMenu>
    </Box>
  );
};
